<template>
  <div>
    <el-button
      class="btnShared"
      type="primary"
      icon="el-icon-share"
      @click="openDialogShare"
      circle
    ></el-button>
    <el-dialog title="Compartir ubicacion" width="30%" :visible.sync="dialogFormVisible">
      <el-tabs v-model="activeName">
        <el-tab-pane label="Compartir enlace" name="link">
          <el-row :gutter="20">
            <el-col :span="24"
              ><div class="lblAddress">{{ addresslocal }}</div></el-col
            >
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24"
              ><div class="lblNombre">Enlace para compartir</div></el-col
            >
          </el-row>
          <el-row :gutter="20">
            <el-col :span="21" id="foo">
              <el-input
                class="address_share_link"
                ref="urlLinkAddress"
                v-model="url"
              ></el-input>
            </el-col>
            <el-col :span="3">
              <el-tooltip
                class="item"
                effect="dark"
                content="Copiar"
                placement="top"
              >
                <i
                  @click="copyText"
                  style="cursor: pointer"
                  class="el-icon-document-copy"
                ></i>
              </el-tooltip>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      dialogFormVisible: false,
      activeName: "link",
      url: "",
      addresslocal: "",
    };
  },
  computed: {
    ...mapState(["latitud_general", "longitud_general", "place_id", "address"]),
  },
  mounted() {
    this.addresslocal = this.address;
    this.url = process.env.VUE_APP_PATH + `/place_id/${this.place_id}`;
  },
  methods: {
    openDialogShare() {
      this.addresslocal = this.address;
      this.url = process.env.VUE_APP_PATH + `/place_id/${this.place_id}`;
      this.dialogFormVisible = true;
    },
    copyText() {
      var vm = this;
      /* Get the text field */
      var copyText = vm.$refs.urlLinkAddress;
      /* Select the text field */
      copyText.select();
      /* Copy the text inside the text field */
      document.execCommand("copy");
      /* Alert the copied text */
      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        console.log("Fallback: Copying text command was " + msg);
      } catch (err) {
        console.error("Fallback: Oops, unable to copy", err);
      }
    },
  },
};
</script>
<style>
.lblAddress {
  font-weight: bold;
  margin: 15px 0px;
}

.lblNombre {
  color: #838383;
  margin: 15px 0px;
}

.btnShared {
  position: fixed;
  z-index: 1000;
  top: 60px;
  right: 35px;
  background: #2164f9 !important;
  border-color: #2164f9 !important;
}

.address_share_link .el-input__inner {
  width: 100%;
  height: 25px;
  font-weight: bold;
  color: #008944;
  font-size: 12px;
  padding: 0 3px;
}
</style>